import { AccountBox } from "@mui/icons-material";
import { Typography } from "@mui/material";
import React from "react";
import { UserObjectStore } from "../../ObjectStore/UserObjectStore";


const User: React.FC = () => {
    const { userObjectState } = React.useContext(UserObjectStore)

    return (
        <>
            {userObjectState.stfId &&
                <Typography
                    color="inherit"
                    noWrap
                    textAlign="right"
                    alignItems="center"
                >
                    <AccountBox
                        sx={{
                            verticalAlign: "middle",
                        }}
                    />
                    {userObjectState.stfName}
                </Typography>
            }
        </>
    );
}

export default User